<template>
  <div id="app">
<keep-alive>
    <router-view v-if="$route.meta.keepAlive">

    </router-view>
</keep-alive>
<router-view v-if="!$route.meta.keepAlive">

    </router-view>

  </div>
</template>

<script>
import header from '@/components/header.vue'

export default {
  name: 'App',
  components: {
    'headerNav': header,
    transitionName: 'transitionLeft'
  },
  created () {
    // var switch_pc = window.location.hash
    // var pathname = window.location.pathname
    // // eslint-disable-next-line camelcase
    // if (!/iphone|ipod|ipad|ipad|Android|nokia|blackberry|webos|webos|webmate|bada|lg|ucweb|skyfire|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile/i.test(navigator.userAgent.toLowerCase())) {
    //   location.href = 'http://m.buypos.cn/pc/home.html#/'
    // }
    this.initpage()
    window.onresize = () => {
      this.initpage()
    }
    var _hmt = _hmt || [];
    (function () {
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?4abeaaf09c3ec6588b99ebd5793c59f1'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
  },
  watch: {
  // '$route' (to, from) {
  //  const arr = ['/software','/tutorialDown','/troubleshooting'];
  //  const compare = arr.indexOf(to.path)>arr.indexOf(from.path);
  //  this.transitionName = compare ? 'slide-right' : 'slide-left';
  // }
  },
  methods: {
    initpage () {
      var docEl = document.documentElement
      var width = docEl.clientWidth > 768 ? 768 : docEl.clientWidth
      var fontsize = 12 * (width / 320) > 12 ? 12 * (width / 320) : 12
      docEl.style.fontSize = fontsize + 'px'
    }
  }
}
</script>

<style>
/* .child-view {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: all 0.5s cubic-bezier(.55,0,.1,1);
}
.slide-left-enter, .slide-right-leave-active {
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}
.slide-left-leave-active, .slide-right-enter {
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100%, 0);
}
.transitionBody{
 transition: all 0.5s ease;
}

.transitionLeft-enter,
.transitionRight-leave-active {
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}

.transitionLeft-leave-active,
.transitionRight-enter {
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100%, 0);
} */
</style>



// WEBPACK FOOTER //
// src/App.vue